import moment from "moment";
import React from "react";
import NumberFormat from "react-number-format";
import { modeOfTravel } from "./../../actions/EtourAction";
import { onChange, setOptions, validateForm } from "./../../utils";

class ComponentName extends React.Component<any, any> {
  constructor(props: any) {
    super(props);
    const detail = props.detail;
    this.state = {
      id: detail ? detail.id : "",
      minDate: "",
      maxDate: "",
      startDate: { name: "startDate", value: "", error: "", isRequired: true },
      endDate: { name: "endDate", value: "", error: "", isRequired: true },
      startTime: { name: "startTime", value: "", error: "", isRequired: true },
      endTime: { name: "endTime", value: "", error: "", isRequired: true },
      from: {
        name: "from",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      to: { name: "to", value: "", options: [], error: "", isRequired: true },
      modeOfTravel: {
        name: "modeOfTravel",
        value: "",
        options: [],
        error: "",
        isRequired: true,
      },
      otherModeOfTravel: {
        name: "otherModeOfTravel",
        value: "",
        error: "",
        isRequired: false,
      },
      class: { name: "class", value: "", error: "", isRequired: true },
      fare: { name: "fare", value: "", error: "", isRequired: true },
      da: { name: "da", value: "", error: "", isRequired: false },
      total: { name: "total", value: "", error: "", isRequired: true },
    };
  }

  render() {
    const {
      startDate,
      endDate,
      startTime,
      endTime,
      from,
      to,
      modeOfTravel,
      fare,
      total,
      otherModeOfTravel,
    } = this.state;
    // const { showLoader } = this.state;
    // Add ETour, start date should not be less than 2 month and next date should not be greater than 3 months
    return (
      <div>
        <div className="row">
          <div className="col-md-12">
            <form onSubmit={this.onSubmit}>
              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      {" "}
                      Start Date <small>*</small>
                    </label>
                    <input
                      type="date"
                      className={
                        startDate.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={startDate.name}
                      value={startDate.value}
                      onChange={this.onChange}
                      min={moment().subtract(2, "month").format("YYYY-MM-DD")}
                      max={moment().add(3, "month").format("YYYY-MM-DD")}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      Time <small>*</small>
                    </label>
                    <input
                      type="time"
                      className={
                        startTime.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={startTime.name}
                      value={startTime.value}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      End Date <small>*</small>
                    </label>
                    <input
                      type="date"
                      className={
                        endDate.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={endDate.name}
                      value={endDate.value}
                      onChange={this.onChange}
                      min={moment().subtract(2, "month").format("YYYY-MM-DD")}
                      max={moment().add(3, "month").format("YYYY-MM-DD")}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      Time <small>*</small>
                    </label>
                    <input
                      type="time"
                      className={
                        endTime.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={endTime.name}
                      value={endTime.value}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      From <small>*</small>
                    </label>
                    <input
                      type="text"
                      className={
                        from.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={from.name}
                      value={from.value}
                      onChange={this.onChange}
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label>
                      To <small>*</small>
                    </label>
                    <input
                      type="text"
                      className={
                        to.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={to.name}
                      value={to.value}
                      onChange={this.onChange}
                    />
                  </div>
                </div>

                <div className="col-md-12">
                  <div className="form-group">
                    <label>
                      Mode of travel <small>*</small>
                    </label>

                    <select
                      className={
                        modeOfTravel.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      name={modeOfTravel.name}
                      value={modeOfTravel.value}
                      onChange={this.onChange}
                    >
                      <option> Select </option>

                      {modeOfTravel.options.length > 0 &&
                        modeOfTravel.options.map((ele: any, index: any) => {
                          return (
                            <option value={ele.modeOfTravel} key={index}>
                              {" "}
                              {ele.modeOfTravel}{" "}
                            </option>
                          );
                        })}
                    </select>

                    {/* 
                            <input
                            type="text"
                            className={modeOfTravel.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                            placeholder=""
                            name={modeOfTravel.name}
                            value={modeOfTravel.value}
                            onChange={this.onChange}
                            />
                            */}
                  </div>
                </div>

                {modeOfTravel.value == "Others" ? (
                  <div className="col-md-12">
                    <div className="form-group">
                      <input
                        type="text"
                        className={
                          otherModeOfTravel.error.length > 0
                            ? "form-control is-invalid"
                            : "form-control"
                        }
                        placeholder=""
                        name={otherModeOfTravel.name}
                        value={otherModeOfTravel.value}
                        onChange={this.onChange}
                      />
                    </div>
                  </div>
                ) : (
                  ""
                )}

                <div className="col-md-12">
                  <div className="form-group">
                    <label>
                      {" "}
                      Class <small> * </small>
                    </label>
                    <input
                      type="text"
                      className={
                        this.state.class.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={this.state.class.name}
                      value={this.state.class.value}
                      onChange={this.onChange}
                    />
                  </div>
                </div>

                <div className="col-md-8">
                  <div className="form-group">
                    <label>
                      Fare <small>*</small>
                    </label>
                    <NumberFormat
                      decimalScale={2}
                      thousandSeparator={true}
                      allowNegative={false}
                      className={
                        fare.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      name={fare.name}
                      value={fare.value}
                      onValueChange={(e: any) => {
                        this.onChange({
                          target: { name: fare.name, value: e.value },
                        });
                      }}
                    />
                  </div>
                </div>

                {/* <div className="col-md-4">
                                    <div className="form-group">
                                        <label>D.A. <small>*</small></label>
                                        
                                         <NumberFormat
                                            thousandSeparator={true}
                                            decimalScale={2}
                                            allowNegative={false}
                                            className={da.error.length > 0 ? 'form-control is-invalid' : 'form-control'}
                                            placeholder=""
                                            name={da.name}
                                            value={da.value}
                                            onValueChange={(e: any) => { this.onChange({ target: { name: da.name, value: e.value } }) }}
                                          />
                                           
                                    </div>
                                </div>   */}

                <div className="col-md-4">
                  <div className="form-group">
                    <label>
                      Total <small>*</small>
                    </label>

                    <NumberFormat
                      decimalScale={2}
                      thousandSeparator={true}
                      allowNegative={false}
                      className={
                        total.error.length > 0
                          ? "form-control is-invalid"
                          : "form-control"
                      }
                      placeholder=""
                      disabled={true}
                      name={total.name}
                      value={total.value}
                    />
                  </div>
                </div>

                <div className="col-md-3">
                  <button
                    type="button"
                    onClick={this.props.onCancel}
                    className="btn btn-block cancel-button btn-sm btn-sm"
                  >
                    Cancel
                  </button>
                </div>
                <div className="col-md-6">&nbsp;</div>
                <div className="col-md-3">
                  <button
                    type="submit"
                    className="btn btn-block submit-button btn-sm"
                  >
                    Submit
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    );
  }

  componentDidMount() {
    // const sd = moment().subtract(2, 'month').format('YYYY-MM-DD');
    // const ed = moment().add(3, 'month').format('YYYY-MM-DD');
    // this.setState({
    //     minDate: sd,
    //     maxDate: ed
    // });

    modeOfTravel().then((res: any) => {
      setOptions(this, this.state.modeOfTravel.name, res.result);
      // this.setState({ reimbursementDetail: res.result });
    });
  }

  onChange = (e: any) => {
    let name = e.target.name;
    let value = e.target.value;

    onChange(this, e.target.name, e.target.value, () => {
      const {  fare, total } = this.state;

      const sum = parseFloat(fare.value) + 0;
      const nanCheck = isNaN(sum);
      !nanCheck && onChange(this, total.name, sum);
    });
  };

  onSubmit = (e: any) => {
    e.preventDefault();
    if (validateForm(this) && this.compareDates()) {
      const st = this.state;
      this.setState({ showLoader: true });
      const model = {
        id: st.id,
        startDate: st.startDate.value,
        endDate: st.endDate.value,
        startTime: st.startTime.value,
        endTime: st.endTime.value,
        from: st.from.value,
        to: st.to.value,
        modeOfTravel:
          st.modeOfTravel.value == "Others"
            ? st.otherModeOfTravel.value
            : st.modeOfTravel.value,
        class: st.class.value,
        fare: parseFloat(st.fare.value),
        da: 0,
        total: st.total.value,
      };
      if (st.id === "") {
        model.id = new Date().getTime();
      }
      this.props.onSubmit(model);
    }
  };

  compareDates = () => {
    const st = this.state;
    const startDate = moment(st.startDate.value);
    const endDate = moment(st.endDate.value);
    const diff = endDate.diff(startDate);

    if (diff >= 0) {
      return true;
    } else {
      alert("Start date must be less than end date");
      return false;
    }
  };
}

export default ComponentName;
